import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  badgeVariableContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2px',
    marginTop: '8px'
  },
  badgeVariable: {
    // Estilo dos chips de variável na Accordion
    padding: '8px 0px',
    height: '15px',
    borderRadius: '4px',
    fontSize: '.8rem',
    background: 'transparent',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    border: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`,
    '&:hover': {
      background: 'transparent',
      borderColor: theme.palette.blue_300.main
    }
  },
  accordion: {
    backgroundColor: 'transparent',
    border: 'none',
    margin: `-5px 0px !important`,
    padding: '0px',
    '&::before': { display: 'none' }
  },
  accordionSummary: {
    minHeight: '12px !important',
    padding: '0 8px 0 0',
    '& .MuiAccordionSummary-content': { margin: '0' },
    '& .MuiIconButton-root': { padding: '2px', marginRight: '0px' },
    '&.MuiAccordionSummary-root': {
      flexDirection: 'row-reverse',
      padding: '0'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  accordionDetails: {
    padding: '0 8px 0',
    display: 'flex',
    flexWrap: 'wrap'
  },
  heading: {
    fontSize: '.8rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  // ESTILOS EXCLUSIVOS DO EDITOR CONTENTEDITABLE
  label: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '1rem'
  },
  editorWrapper: {
    width: '100%',
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRadius: 8,
    position: 'relative',
    minHeight: 72, // Altura mínima para o campo de edição
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
    // padding: 4 // Padding menor para deixar o editor mais "nativo"
  },
  editorContent: {
    // A div contentEditable real
    minHeight: 120,
    maxHeight: 120,
    width: '100%', // Ocupa 100% do wrapper
    boxSizing: 'border-box', // Garante que o padding não "empurre" a largura para fora
    wordBreak: 'break-word', // Força a quebra de palavras muito longas
    overflowWrap: 'anywhere', // Garante que o texto flua corretamente
    overflowY: 'auto',
    ...theme.scrollbarStyles,
    padding: '12px 14px',
    fontSize: '1rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    cursor: 'text',
    outline: 'none',
    // fontFamily: 'Noto Color Emoji, sans-serif',

    // Estilo da variável inserida (TAG AZUL)
    '& .variavel-tag': {
      userSelect: 'none', // Impede selecionar o texto interno da tag
      display: 'inline-block', // Trata a tag como um bloco único
      pointerEvents: 'none',
      maxWidth: '90%',
      alignItems: 'center',
      backgroundColor: theme.palette.info.main, // Azul
      color: theme.palette.common.white,
      padding: '2px 6px',
      margin: '3px 3px 3px 1px',
      borderRadius: theme.shape.borderRadius,
      fontSize: '14px',
      cursor: 'default',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle'
    },
    '& .variavel-tag .close-btn': {
      display: 'inline-flex',
      alignItems: 'center',
      marginLeft: 6,
      fontWeight: 'bold',
      cursor: 'pointer',
      opacity: 0.8,
      transition: 'opacity 0.2s',
      '&:hover': { opacity: 1 }
    },
    // Placeholder
    '&:empty:before': {
      content: 'attr(data-placeholder)',
      color: theme.palette.grey[500],
      pointerEvents: 'none',
      display: 'block'
    }
  },

  //Emoji
  boxEmojiContainer: {
    marginTop: '-39px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  //   emojiBox: {
  //   position: 'absolute',
  //   // height: '40px',
  //   // top: '-30px',
  //   // left: '-5px',
  //   zIndex: 1000,
  //   // '& .emoji-mart-bar': {
  //   //   display: 'none'
  //   // },
  //   // '& .emoji-mart-scroll': {
  //   //   ...theme.scrollbarStyles
  //   // }
  // },
  button: {
    margin: '4px',
    padding: '6px',
    color: theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: 'transparent !important'
      // color: theme.palette.yellow_500.main,
    }
  }
}))
